import Login from "../pages/login/components/Login";
import Proceed from "../pages/login/components/Proceed";
import Congrats from "../pages/login/components/Congrats";
import Details from "../pages/subscription/component/Details";
import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import SubscriptionLogin from "../pages/subscription/component/SubscriptionLogin";
import DeviceList from "../pages/subscription/component/DeviceList";
import PrivateRoutes from "./PrivateRoute";
import NotFoundPage from "../pages/common/components/NotFoundPage";
import TnC from "../pages/tnc/components/TnC";
import TnCongrats from "../pages/tnc/components/TnCongrats";
import ReviewPlanDetails from "../pages/family-plan/components/ReviewPlanDetails";
import ActivateWatch from "../pages/family-plan/components/ActivateWatch";
import ServiceAgreement from "../pages/family-plan/components/ServiceAgreement";
import SetUp from "../pages/family-plan/components/SetUp";
import CongratsFamilyPlan from "../pages/family-plan/components/CongratsFamilyPlan";

export default function AppRoute() {
    return (
        <div>
            <Router
                // basename={"/ws"}
            >
                <Routes>
                    <Route exact path="/" element={<Login/>}/>
                    <Route exact path="/not-found-page" element={<NotFoundPage/>}/>
                    <Route exact path="/vowifi/terms-and-condition" element={<TnC/>}/>
                    <Route exact path="/vowifi/terms-and-condition/congrats" element={<TnCongrats/>}/>

                    <Route exact path="/review-plan-details" element={<ReviewPlanDetails/>}/>
                    <Route exact path="/activate-watch" element={<ActivateWatch/>}/>
                    <Route exact path="/service-agreement" element={<ServiceAgreement/>}/>
                    <Route exact path="/set-up" element={<SetUp/>}/>
                    <Route exact path="/proceed/family-plan-congrats" element={<CongratsFamilyPlan/>}/>

                    <Route element={<PrivateRoutes/>}>
                        <Route exact path="/proceed" element={<Proceed/>}/>
                        <Route exact path="/proceed/congrats" element={<Congrats/>}/>
                        <Route exact path="/manage-subscription" element={<SubscriptionLogin/>}/>
                        <Route exact path="/manage-subscription/device-list" element={<DeviceList/>}/>
                        <Route exact path="/manage-subscription/device-list/details" element={<Details/>}/>
                    </Route>
                </Routes>
            </Router>
        </div>
    )
}